import { ModuleParamGlobConfigService } from '../../../core/service/moduleFieldConfig/module-param-glob-config.service';

export class soModuleParamConfigModel {
  constructor(private moduleParamConfigGlob: ModuleParamGlobConfigService) {}

  paramData = {
    contactPerson: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'contactPerson', 'Contact Person'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrder', 'contactPerson'),
      isRequired: this.moduleParamConfigGlob.isRequired('salesOrder', 'contactPerson'),
    },
    staff_name: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'staff_name', 'Staff Name'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrder', 'staff_name'),
      isRequired: this.moduleParamConfigGlob.isRequired('salesOrder', 'staff_name'),
    },
    shippingAddress: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'shippingAddress', 'Shipping Address'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrder', 'shippingAddress'),
      isRequired: this.moduleParamConfigGlob.isRequired('salesOrder', 'shippingAddress'),
    },

    so_title: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'so_title', 'Shipment Order'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrder', 'so_title'),
    },
    so_details_title: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'so_details_title', 'Shipment Order Details'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrder', 'so_details_title'),
    },
    so_dispatch: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'so_dispatch', 'Dispatch to'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrder', 'so_dispatch'),
    },
    so_slip: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'so_slip', 'Shipment Order Slip'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrder', 'so_slip'),
    },
    so_slip_customer: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'so_slip_customer', 'Customer Details'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrder', 'so_slip_customer'),
    },
    so_slip_cutomer_label: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'so_slip_cutomer_label', 'Customer'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrder', 'so_slip_cutomer_label'),
    },
    so_basic_title: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'so_basic_title', 'Basic Details'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrder', 'so_basic_title'),
    },
    so_generated_from: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'so_generated_from', 'Generated From'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrder', 'so_generated_from'),
    },
    so_name: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'so_name', 'Shipment Order Name'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrder', 'so_name'),
    },
    so_date: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'so_date', 'SO Date'),
    },
    so_number: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'so_number', 'SO Number'),
    },
    party_name: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'party_name', 'Party Name'),
      isRequired: this.moduleParamConfigGlob.isRequired('salesOrder', 'party_name'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrder', 'party_name'),
    },
    parameter_detail: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'parameter_detail', 'Parameter Detail'),
    },
    so_print: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'so_print', 'Print'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrder', 'so_print'),
    },
    so_for: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'so_for', 'For'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrder', 'so_for'),
    },
    so_sign: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'so_sign', 'Authorised Sign'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrder', 'so_sign'),
    },
    po_reference: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'po_reference', 'PO Reference'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrder', 'po_reference'),
      isRequired: this.moduleParamConfigGlob.isRequired('salesOrder', 'po_reference')
    },
    po_date: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'po_date', 'PO Date'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrder', 'po_date'),
      isRequired: this.moduleParamConfigGlob.isRequired('salesOrder', 'po_date')
    },
    so_remark: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'so_remark', 'Remark'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrder', 'so_remark'),
    },
    so_price: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'so_price', 'Price'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrder', 'so_price'),
    },
    so_uom: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'so_uom', 'UOM'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrder', 'so_uom'),
    },
    so_total_amount: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'so_total_amount', 'Total Amount'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrder', 'so_total_amount'),
    },
    so_total: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'so_total', 'Total'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrder', 'so_total'),
    },
    so_quality: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'so_quality', 'Quality Parameters'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrder', 'so_quality'),
    },
    so_quality_detail: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'so_quality_detail', 'Quality Parameters Details'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrder', 'so_quality_detail'),
    },
    so_packing: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'so_packing', 'Packing Details'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrder', 'so_packing'),
    },
    so_packing_type: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'so_packing_type', 'Packing Type'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrder', 'so_packing_type'),
    },
    freight_type: {
      label: this.moduleParamConfigGlob.getLabel('freight', 'freight_type', 'Freight Type'),
      isVisible: this.moduleParamConfigGlob.isVisible('freight', 'freight_type'),
      isRequired: this.moduleParamConfigGlob.isRequired('freight', 'freight_type'),
    },
    freight_price: {
      label: this.moduleParamConfigGlob.getLabel('freight', 'freight_price', 'Freight Price'),
      isVisible: this.moduleParamConfigGlob.isVisible('freight', 'freight_price'),
      isRequired: this.moduleParamConfigGlob.isRequired('freight', 'freight_price'),
    },
    so_packing_capacity: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'so_packing_capacity', 'Capacity'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrder', 'so_packing_capacity'),
    },
    so_no_of_packing: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'so_no_of_packing', 'Number of Packages'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrder', 'so_no_of_packing'),
    },
    customerExpectedDate: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'customerExpectedDate', 'Request Shipping Date'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrder', 'customerExpectedDate'),
    },
    estimatedShippingDate: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'estimatedShippingDate', 'Estimated Shipping Date'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrder', 'estimatedShippingDate'),
    },
    tentativeCompletionDate: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'tentativeCompletionDate', 'Tentative Completion Date'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrder', 'tentativeCompletionDate'),
    },
    actualCompletionDate: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'actualCompletionDate', 'Actual Completion Date'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrder', 'actualCompletionDate'),
    },
    so_material_details: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'so_material_details', 'Material Details'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrder', 'so_material_details'),
    },
    so_material: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'so_material', 'Material'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrder', 'so_material'),
    },
    labelName: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'labelName', 'Label Name'),
    },
    so_from_label: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'so_from_label', 'Shipment Order'),
    },
    customer: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'customer', 'Customer'),
    },
    label: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'label', 'Label'),
    },
    stock: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'stock', 'Stock'),
    },
    blockedStock: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'blockedStock', 'Blocked Stock'),
    },
    uom: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'uom', 'UOM'),
    },
    rack: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'rack', 'Rack'),
    },
    vendorCode: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'vendorCode', 'Vendor Code'),
    },
    packingType: {
      label: this.moduleParamConfigGlob.getLabel('salesOrder', 'packingType', 'Packing Type'),
    },
  };
  labelProduct = {
    label: this.moduleParamConfigGlob.getLabel('salesOrderDetails', 'labelProduct', 'Label Product'),
    isVisible: this.moduleParamConfigGlob.isVisible('salesOrderDetails', 'labelProduct'),
    isRequired: this.moduleParamConfigGlob.isRequired('salesOrderDetails', 'labelProduct'),
  };
  isLabelProduct = {
    label: this.moduleParamConfigGlob.getLabel('salesOrderDetails', 'isLabelProduct', 'With IML'),
    isVisible: this.moduleParamConfigGlob.isVisible('salesOrderDetails', 'isLabelProduct'),
    isRequired: this.moduleParamConfigGlob.isRequired('salesOrderDetails', 'isLabelProduct'),
  };
  soDetails = {
    details_title: {
      label: this.moduleParamConfigGlob.getLabel('salesOrderDetails', 'details_title', 'Details'),
    },
    material_name: {
      label: this.moduleParamConfigGlob.getLabel('salesOrderDetails', 'material_name', 'Material Name'),
    },
    material_code: {
      label: this.moduleParamConfigGlob.getLabel('salesOrderDetails', 'material_code', 'Item Code'),
    },
    color: {
      label: this.moduleParamConfigGlob.getLabel('salesOrderDetails', 'color', 'Color'),
    },
    filler: {
      label: this.moduleParamConfigGlob.getLabel('salesOrderDetails', 'filler', 'Filler'),
    },
    grade: {
      label: this.moduleParamConfigGlob.getLabel('salesOrderDetails', 'grade ', 'Grade'),
    },
    total_material_qty: {
      label: this.moduleParamConfigGlob.getLabel('salesOrderDetails', 'total_material_qty', 'Total Material Qty'),
    },
    size: {
      label: this.moduleParamConfigGlob.getLabel('salesOrderDetails', 'size', 'Size'),
    },
    price_per_material_qty: {
      label: this.moduleParamConfigGlob.getLabel(
        'salesOrderDetails',
        'price_per_material_qty',
        'Price Per Material Qty'
      ),
    },
    labelName: {
      label: this.moduleParamConfigGlob.getLabel('salesOrderDetails', 'labelName', 'Label Name'),
    },
    name: {
      label: this.moduleParamConfigGlob.getLabel('salesOrderDetails', 'name', 'Name'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrderDetails', 'name'),
    },
    type: {
      label: this.moduleParamConfigGlob.getLabel('salesOrderDetails', 'type', 'Type'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrderDetails', 'type'),
    },
    value: {
      label: this.moduleParamConfigGlob.getLabel('salesOrderDetails', 'value', 'Value'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrderDetails', 'value'),
    },
    tolerance: {
      label: this.moduleParamConfigGlob.getLabel('salesOrderDetails', 'tolerance', 'Tolerance'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrderDetails', 'tolerance'),
    },
    terms_condition: {
      label: this.moduleParamConfigGlob.getLabel('salesOrderDetails', 'terms_condition', 'Terms And Conditions'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrderDetails', 'terms_condition'),
    },
    product_detail: {
      label: this.moduleParamConfigGlob.getLabel('salesOrderDetails', 'product_detail', 'Product Detail'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrderDetails', 'product_detail'),
    },
    bank_title: {
      label: this.moduleParamConfigGlob.getLabel('salesOrderDetails', 'bank_title', 'Bank Details'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrderDetails', 'bank_title'),
    },
    bank_name: {
      label: this.moduleParamConfigGlob.getLabel('salesOrderDetails', 'bank_name', 'Bank Name'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrderDetails', 'bank_name'),
    },
    account_holder: {
      label: this.moduleParamConfigGlob.getLabel('salesOrderDetails', 'account_holder', 'Account Holder'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrderDetails', 'account_holder'),
    },
    account_no: {
      label: this.moduleParamConfigGlob.getLabel('salesOrderDetails', 'account_no', 'Account Number'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrderDetails', 'account_no'),
    },
    ifsc_code: {
      label: this.moduleParamConfigGlob.getLabel('salesOrderDetails', 'ifsc_code', 'IFSC Code'),
      isVisible: this.moduleParamConfigGlob.isVisible('salesOrderDetails', 'ifsc_code'),
    },
  };
}
